<template>
  <ReportBaseSelectFilter
    :label="taskLabel"
    :placeholder="taskPlaceholder"
    query-property="tasks"
    :options="options"
    :disabled="disabled"
    :disabled-tooltip="disabledTooltip"
  />
</template>

<script>
import { sortBy } from 'lodash-es';
import { mapGetters, mapState } from 'vuex';
import { getTaskFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'ReportTaskFilter',
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
      allTasks: ({ tasks }) => tasks,
    }),
    ...mapState(['organization']),
    ...mapGetters(['applyingSavedReportFilter']),
    disabledTooltip() {
      return this.disabled && !this.applyingSavedReportFilter
        ? 'Cannot filter report by to-dos. Please turn on "Show to-dos" to use to-dos filtering.'
        : '';
    },
    options() {
      return sortBy(
        this.allTasks.map((task) => ({ id: task.id, text: task.summary })),
        (task) => task.text.toLowerCase(),
      );
    },
    taskLabel() {
      return getTaskFlavourLabel(this.organization.project_flavour, true);
    },
    taskPlaceholder() {
      return `All ${this.taskLabel.toLowerCase()}`;
    },
  },
};
</script>
